import { ExpandedTourDatesByYear } from "../models/ExpandedTourDatesByYear";
import { IExpandedTourDate } from "../models/IExpandedTourDate";
import { ITourDate } from "../models/ITourDate";
import TourService from "./TourService";

export default class TourDateService {
  getTourDatesGroupedByYear = async (): Promise<ExpandedTourDatesByYear> => {
    const tourDatesResponse = await fetch(`${process.env.REACT_APP_BASE_API_URL}/api/tour-dates`);

    const tours = new TourService().getTours()
    const tourDates = (await tourDatesResponse.json()) as ITourDate[];

    const expandedDates: IExpandedTourDate[] = tourDates.map(date => {
      const tour = tours.find(t => t.id === date.tourId);
      if (!tour) throw new Error(`Tour not found for tourId ${date.tourId}`);

      return {
        id: date.id,
        year: date.year,
        startDate: date.startDate,
        endDate: date.endDate,
        availableSpots: date.availableSpots,
        tour: tour
      };
    });

    const grouped: ExpandedTourDatesByYear = expandedDates.reduce((acc, date) => {
      if (!acc[date.year]) acc[date.year] = [];
      acc[date.year].push(date);
      return acc;
    }, {} as ExpandedTourDatesByYear);

    return grouped;
  };
}